<script lang="ts">
  import { fadeSlide } from "../utils/transition";
  import { circInOut } from "svelte/easing";
  import Modal from "./Modal.svelte";
  import Popper from "./Popper.svelte";
  import BottomSheet from "./BottomSheet.svelte";

  export let overlay: "inline" | "modal" = "inline";
  export let open: boolean;
  export let input: HTMLElement;
  export let disableAutoClose: boolean = false;

  const isMobile = matchMedia("(max-width: 991.98px)").matches;
</script>

{#if isMobile}
  <BottomSheet bind:open on:close let:overlay>
    <slot {overlay} />
    <slot name="footer" slot="footer" />
  </BottomSheet>
{:else if overlay === "inline"}
  <Popper {input} {disableAutoClose} coverInput bind:open on:close let:overlay>
    <div class="popper" transition:fadeSlide={{ duration: 150, easing: circInOut }}>
      <slot {overlay} />
      <slot name="footer" />
    </div>
  </Popper>
{:else}
  <Modal bind:open {disableAutoClose} on:close let:overlay>
    <slot name="title" slot="title" />
    <slot {overlay} />
    <slot name="footer" slot="footer" />
  </Modal>
{/if}

<style lang="scss">
  .popper {
    position: relative;
    max-width: calc(100vw - 1rem);
    // max-height: calc(100vh - 1rem);
    padding: 20px;
    background-color: #fff;
    box-shadow: 0px 2px 35px -2px rgba(0, 0, 0, 0.15);
    border-radius: 22px;
    margin-bottom: 1rem;
  }
</style>
